"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GrantType = void 0;
var GrantType;
(function (GrantType) {
    GrantType["Password"] = "password";
    GrantType["RefreshToken"] = "refresh_token";
    GrantType["ClientCredentials"] = "client_credentials";
})(GrantType || (exports.GrantType = GrantType = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZ3JhbnQtdHlwZS5lbnVtLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL29hdXRoL2dyYW50LXR5cGUuZW51bS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBQSxJQUFZLFNBSVg7QUFKRCxXQUFZLFNBQVM7SUFDakIsa0NBQXFCLENBQUE7SUFDckIsMkNBQThCLENBQUE7SUFDOUIscURBQXdDLENBQUE7QUFDNUMsQ0FBQyxFQUpXLFNBQVMseUJBQVQsU0FBUyxRQUlwQiJ9